import { render, staticRenderFns } from "./expenseLedger.vue?vue&type=template&id=237077ec&scoped=true"
import script from "./expenseLedger.vue?vue&type=script&lang=js"
export * from "./expenseLedger.vue?vue&type=script&lang=js"
import style0 from "./expenseLedger.vue?vue&type=style&index=0&id=237077ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237077ec",
  null
  
)

export default component.exports